


















































































































import { Component, Mixins } from 'vue-property-decorator';
import { digits } from '@nodes/helpers/number';
import { YIcon } from '@components/Icon';
import Auth from '@rogues/Auth/shared/auth';
import YAuthLogin from '@/rogues/Auth/blocks/Login/index.vue';
import YAuthRegister from '@/rogues/Auth/blocks/Register/index.vue';
import YAuthForget from '@/rogues/Auth/blocks/Forget/index.vue';

@Component({
    components: {
        YIcon,
        YAuthLogin,
        YAuthRegister,
        YAuthForget,
    },
})
/**
 * @name Modern
 */
export default class Modern extends Mixins(Auth) {
    digits = digits;

    /**
     * Style of the image div
     * 
     * @returns {object}
     */
    get styleObject(): object {
        return {
            backgroundImage: `url(${this.getValue('img')})`,
        };
    }

    /**
     * Check if Form Has Footer
     * 
     * @returns {boolean}
     */
    get hasFormFooter(): boolean {
        return this.getBoolean('form_footer') || this.getBoolean('quarkino_branding');
    }

    /**
     * Format tel number
     * 
     * @param {string | number} tel
     * @returns {string}
     */
    telLink(tel: number): string {
        let num = this.digits(tel, 'en');
        if (String(num)[0] === String(0)) {
            num = String(num).slice(1);
        }
        
        num = String(num).replace('-', '');
        return `tel:+98${this.digits(parseInt(num.toString(), 10), 'en')}`;
    }
}
